<nav class="navbar navbar-expand-lg navbar-light bg-white">
  <div class="container-fluid">

  <a class="navbar-brand" href="{{baseUrl}}">
    <img src="assets/images/scr.svg" width="138" height="38" alt="SCR">
  </a>
  <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div *ngIf="!showSearch" class="ms-5 collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav me-auto">
      <li *ngIf="!servicedesk" class="nav-item">
        <div>
          <button type="button" id="dropdownMenuButton" class="btn btn-sm btn-header dropdown-toggle dropdown-toggle-split"
             aria-haspopup="true" aria-expanded="false" (click)="navigateTo(dropDownItems.ShortCodes101)">
            About Short Codes
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" href="{{dropDownItems.ShortCodes101}}">Short Codes 101</a>
            <a class="dropdown-item" href="{{dropDownItems.HowShortCodesWork}}">How Short Codes Work</a>
            <a class="dropdown-item" href="{{dropDownItems.UseCases}}">Use Cases</a>
            <a class="dropdown-item" href="{{dropDownItems.CaseStudies}}">Case Studies</a>
            <!-- <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="{{dropDownItems.HowShortCodesWork}}">Separated link Example</a>  -->
          </div>
        </div>
      </li>
      <li *ngIf="!servicedesk" class="nav-item">
        <div>
          <button type="button" id="dropdownMenuButton" class="btn btn-sm btn-header dropdown-toggle dropdown-toggle-split"
            aria-haspopup="true" aria-expanded="false" (click)="navigateTo(dropDownItems.FindAPartner)">
            Partners
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" href="{{dropDownItems.FindAPartner}}">Find a Partner</a>
            <a class="dropdown-item" href="{{dropDownItems.AboutShortCodePartners}}">About Short Code Partners</a>
            <a class="dropdown-item" href="{{dropDownItems.BecomeAPartner}}">Become a Partner</a>
            <a class="dropdown-item" href="{{dropDownItems.PartnerDirectory}}">Partner Directory</a>
          </div>
        </div>
      </li>
      <li *ngIf="!servicedesk" class="nav-item">
        <div>
          <button type="button" id="dropdownMenuButton" class="btn btn-sm btn-header dropdown-toggle dropdown-toggle-split"
            aria-haspopup="true" aria-expanded="false" (click)="navigateTo(dropDownItems.FAQs)">
            Learn More
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" href="{{dropDownItems.FAQs}}">FAQs</a>
            <a class="dropdown-item" href="{{dropDownItems.NewsAndInformation}}">News and Information</a>
            <a class="dropdown-item" href="{{dropDownItems.Resources}}">Resources</a>
          </div>
        </div>
      </li>
    </ul>
    <ul class="navbar-nav flex-row me-2">
      <li id="filledBar" class="nav-item nav-item-active" *ngIf="signedIn" >
        <div>
          <button type="button" id="dropdownMenuButton" class="btn btn-sm btn-header dropdown-toggle dropdown-toggle-split"
            aria-haspopup="true" aria-expanded="false">
            My Account
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" href="{{dropDownItems.Dashboard}}">Dashboard</a>
            <a class="dropdown-item" href="{{dropDownItems.Help}}" target="_blank">Help</a>
            <a class="dropdown-item" (click)="logout()" style="cursor: pointer;">Log Out</a>
          </div>
        </div>
      </li>

      <li id="filledBar" class="nav-link nav-link-active">
        <button id="headerLoginButton" *ngIf="!signedIn" routerLink="/sec/login" class="btn btn-header" i18n>Login</button>
      </li>
      <li *ngIf="!servicedesk" class="nav-link">
        <button class="btn btn-primary" i18n (click)="navigateTo(dropDownItems.FindAShortCodeButton)">Find a Short Code</button>
      </li>
        <li *ngIf="!servicedesk" class="icon-seperator" style="border-right: 1px solid #cccccc6b;">
        <a [routerLink]="['/dashboard',{ outlets: { 'navbar-tab': ['order-code', { outlets: { 'order-code-tab': ['cart']  } } ] } }]" id="headerCart">
          <i class="fas fa-cart-shopping center-horizontally-and-vertically" aria-hidden="true">
            <p-badge id="cartCountBadge" *ngIf="cartCount !== '0'" [value]="cartCount" styleClass="p-badge-header"></p-badge>
          </i>
        </a>
      </li>
      <li *ngIf="!servicedesk" class="icon-seperator">
        <a (click)="toggleSearch()" style="cursor: pointer;" id="headerSearchAnchor">
          <i id='headerSearchAnchorIcon' class="fa fa-magnifying-glass center-horizontally-and-vertically" aria-hidden="true" style="text-align: center;width: 100%;">
          </i>
        </a>
      </li>
    </ul>
  </div>
  <div *ngIf="showSearch && !servicedesk" class="ms-5 me-4 collapse navbar-collapse" id="navbarSupportedContent">
    <form id='headerSearchForm' #headerSearchForm="ngForm" class="nav-search-bar-form" style="width: 100%;" (submit)="search()">
      <div id='headerSearchDiv' class="input-group">
        <span id='headerSearchSpan' class="input-group-text bg-white border-0"><i id='headerSearchIcon' class="fas fa-magnifying-glass"></i></span>
        <input type="text" class="nav-search-bar-input form-control" placeholder="Search" 
          [(ngModel)]="searchText" name="headerSearchInput" id="headerSearchInput" #headerSearch (keydown.esc)="clearSearch()">
      </div>
    </form>
    <div class="ms-3"><i id="headerSearchToggle" class="fas fa-xmark icon-teal" (click)="showSearch = !showSearch; headerSearchForm.form.reset()" style="cursor: pointer;"></i></div>
  </div>
</div>
</nav>
<app-linked-accounts-header >

</app-linked-accounts-header>